module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'section-layout': (_vm.parent), 'no-padding': _vm.section.flat
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sectionClicked(_vm.section)
      }
    }
  }, [(!_vm.section.hideTitle) ? _c('div', {
    staticClass: "section-title",
    attrs: {
      "data-key": _vm.section.key
    }
  }, [_c('div', [_vm._v("\n            " + _vm._s(_vm.section.title) + "\n        ")]), _vm._v(" "), _c('div', [_c('div', [_c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": "",
      "nudge-bottom": 6
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "margin": "-4px 0"
          },
          attrs: {
            "text": "",
            "icon": "",
            "color": "grey lighten-1"
          }
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down_circle")])], 1)]
      }
    }], null, false, 1693287487)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-item-title', [_vm._v("Menu Text")])], 1)], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'raised': !_vm.section.flat, 'white-background': !_vm.section.flat, 'no-padding': _vm.section.flat
    }
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    staticClass: "link-button-group"
  }, [(_vm.fieldsNotApplicable.length && !_vm.section.viewNaFields) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$set(_vm.section, 'viewNaFields', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.fieldsNotApplicable.length) + " NA fields")]) : _vm._e(), _vm._v(" "), (_vm.section.viewNaFields && _vm.fieldsNotApplicable.length) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$set(_vm.section, 'viewNaFields', false)
      }
    }
  }, [_vm._v("Hide NA fields")]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b5d3d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/SectionLayout.vue
// module id = 2546
// module chunks = 1